<ngb-datepicker
  [displayMonths]="2"
  [dayTemplate]="t"
  (dateSelect)="onDateSelection($event)"
  outsideDays="hidden"
  class="custom-datepicker"
  [ngStyle]="{ '--calendar-scale': scale }"
></ngb-datepicker>

<ng-template
  #t
  let-date="date"
  let-currentMonth="currentMonth"
  let-selected="selected"
>
  <span
    class="custom-day"
    [class.text-muted]="date.month !== currentMonth"
    [class.range]="(range && isRange(date)) || (!range && isSelected(date))"
    [class.selected]="isSelected(date) && range"
    [class.faded]="range && (isHovered(date) || isInside(date))"
    [class.range-start]="range && fromDate && date.equals(fromDate)"
    [class.range-end]="range && toDate && date.equals(toDate)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null"
  >
    {{ date.day }}
  </span>
</ng-template>